export const versions = {
    version: '25.45.11',
    revision: 'dev',
    branch: 'dev',
};
export const version = versions.version;
export const revision = versions.revision;
export const branch = versions.branch;
